import { Component, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { Station } from '../../../../../../client/model/station';

@Component({
    selector: 'app-sac-mobile-transport-documents',
    templateUrl: './transport-documents.component.html',
    styleUrls: ['./transport-documents.component.scss'],
    standalone: false
})
export class MobileSacTransportDocumentsComponent {

  @Input() station: Station;

  forceRefreshSubject = new Subject<void>();

  public refreshDocuments() {
    this.forceRefreshSubject.next();
  }

}
